import UpdatePasswordForm from '@/components/UpdatePasswordForm';
import { MESSAGES } from '@/constants/messages';
import { ROUTES } from '@/constants/routes';
import { useAccountActivation } from '@/hooks/requests/useAccountActivation';
import { PasswordChallengeStatus } from '@/types/auth';
import { logAnalyticsEvent } from '@/utils/analytics';
import showToast from '@/utils/toast';
import { Card, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type FormInput = {
  password: string;
  confirmPassword: string;
};

export default function ActivationSetPassword() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isLoadingSetPassword, setPassword } = useAccountActivation();

  useEffect(() => {
    if (!state?.setPasswordCode) {
      // Use window.history.back() for more reliable back navigation
      window.history.back();
    }
  }, [state]);

  async function handleSubmit(data: FormInput) {
    try {
      const response = await setPassword({
        set_password_code: state.setPasswordCode,
        password: data.confirmPassword.trim(),
      });

      if (response.status === PasswordChallengeStatus.Valid) {
        navigate(ROUTES.LOGIN);
        showToast({
          type: 'success',
          data: {
            content:
              'Your new password has been set. Enter your credentials below to login',
          },
        });
        logAnalyticsEvent({
          category: 'success',
          action: 'setFirstPasswordFormComplete',
        });
      } else {
        showToast({
          type: 'error',
          data: {
            content: MESSAGES.genericError,
          },
        });
      }
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
      logAnalyticsEvent({
        category: 'error',
        action: 'setFirstPasswordFormError',
      });
    }
  }

  return (
    <Card>
      <Stack spacing={2}>
        <Typography variant="h4">Set Password</Typography>
        <UpdatePasswordForm
          isActivation
          handleSubmit={handleSubmit}
          isLoading={isLoadingSetPassword}
        />
      </Stack>
    </Card>
  );
}
